import React from 'react';
import { connect } from 'react-redux';

import SubscriptionCommitButton from '../components/SubscriptionCommitButton';
import { saveCartRequest, openCartForDesktop } from '../actions';

const mapStateToProps = (state, props) => {
  return {
    canAddCommittableItem: state.currentOrder.can_add_committable_item,
    isProcessing: state.lineItemsProcessing.length > 0,
    hasCanceledSubscription: state.hasCanceledSubscription,
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  handleAddToCartClick: sku => {
    const isCommitting = true;
    const shouldAutoClose = true;
    dispatch(saveCartRequest([{ sku, quantity: 1 }], isCommitting));
    dispatch(openCartForDesktop(shouldAutoClose));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(
  SubscriptionCommitButton
);



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/containers/SubscriptionCommitButton.js